"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jestSonarReporters = void 0;
exports.jestSonarReporters = [
    "@casualbot/jest-sonar-reporter",
    {
        relativePaths: true,
        outputName: 'jest-sonar.xml',
        outputDirectory: './'
    }
];
